import axios from '@axios'

// Один запрос отдаёт все секции; cached_at — время снапшота Planfix-части (раз в час + кнопка «Обновить»).
export default {
  namespaced: true,
  state: {
    cachedAt: null,
    isRefreshing: false,
  },
  getters: {},
  mutations: {
    setCachedAt(state, value) {
      state.cachedAt = value
    },
    setRefreshing(state, value) {
      state.isRefreshing = value
    },
  },
  actions: {
    fetchDashboard(ctx) {
      return axios.get('/dashboard').then(response => {
        const cachedAt = response && response.data && response.data.cached_at
        if (cachedAt) ctx.commit('setCachedAt', cachedAt)
        return response
      })
    },
    fetchCacheStatus() {
      return axios.get('/dashboard/cache-status')
    },
    requestRefresh() {
      return axios.post('/dashboard/refresh')
    },
  },
}
